import { EnumEstadoEventoConcesion } from "../../../Utils/Enumeradores/ComunEnum";
import { useEffect, useState } from "react";

export const AccionesEncabezado = (props) => {
	const { data, dataCompleta, handleShowModal } = props;
	const { Autorizado, Rechazado, Pendiente } = EnumEstadoEventoConcesion;
	const [estadox, setEstadox] = useState(false);
	const Modificar = (item, value) => {
		const esAutorizado = value === 1 ? 1 : 2;
		handleShowModal(item.detalle.map(x => { return Number(x.eventoConcesionId) }), true, esAutorizado);
	}
	
	useEffect(() => {
		const listaParametro = data.map(x => {
			return{
				estadox: x.estado
			};
		});
		const even = (element) => element.estadox === Pendiente;
		setEstadox(listaParametro.some(even));
    }, [props])

	return (
		<div className='d-flex gap-2 ms-auto me-2'>
			<button className='btn btn--outline btn--pewter-blue btn--xs' disabled={!estadox} onClick={() => Modificar(dataCompleta, Autorizado)}>
				<i className='ico-check'></i>
			</button>
			<button className='btn btn--outline btn--pewter-blue btn--xs' disabled={!estadox} onClick={() => Modificar(dataCompleta, Rechazado)}>
				<i className='ico-close'></i>
			</button>
		</div>
	)
}
